import {
  ChatActions,
  MaybeOptimisticChatTextMessage,
  MessageReactionCounts,
} from "@lazarentertainment/public-chat-web"
import styled from "styled-components"

import { ChatView } from "../../constants"

import { ChatMessageBubble } from "./ChatMessageBubble"
import { ChatMessageMenu } from "./ChatMessageMenu"
import { ChatMessageReactionCounter } from "./ChatReactionCounter"

import "@szhsin/react-menu/dist/index.css"

const Container = styled.li`
  display: flex;
  flex-shrink: 0;
  flex-direction: column;
  margin: 0px;
  align-items: flex-start;
  gap: var(--gap-4xs);

  & .chat-message-menu-option {
    visibility: hidden;
  }

  // Allows hovering on mobile when message container is focused
  @media (hover: none) and (pointer: coarse), (hover: hover) {
    &:hover .chat-message-menu-option {
      visibility: visible;
    }
  }
`

const Row = styled.div`
  display: flex;
`

export interface ChatMessageContainerProps {
  message: MaybeOptimisticChatTextMessage
  reactionCounts: MessageReactionCounts
  showModerationTools: boolean
  submitMessageReaction: ChatActions["toggleReaction"]
  banUser: ChatActions["banUser"]
  deleteChatMessage: ChatActions["deleteMessage"]
  view: ChatView
}

export const ChatMessageContainer = ({
  view,
  message,
  reactionCounts,
  showModerationTools,
  submitMessageReaction,
  banUser,
  deleteChatMessage,
}: ChatMessageContainerProps) => {
  return (
    <Container>
      <Row>
        <ChatMessageBubble message={message} view={view} />
        <ChatMessageMenu
          message={message}
          showModerationTools={showModerationTools}
          banUser={banUser}
          deleteChatMessage={deleteChatMessage}
          submitMessageReaction={submitMessageReaction}
          uiView={view}
        />
      </Row>
      <ChatMessageReactionCounter
        uiView={view}
        messageTimetoken={message.timetoken}
        reactionCounts={reactionCounts}
        toggleReaction={submitMessageReaction}
      />
    </Container>
  )
}
